import { Glue42 } from "../../glue";

export default class LayoutImpl implements Glue42.Layouts.Layout {
    /** Name of the layout */
    public name: string;

    /** Type of the layout */
    public type: Glue42.Layouts.LayoutType;

    /** Array of components describing the applications that are saved in the layout */
    public components: Glue42.Layouts.LayoutComponent[];

    /** Context passed when the layout was saved */
    public context: any;

    /** Metadata passed when the layout was saved */
    public metadata: any;

    /** Version of the layout */
    public version: number;

    /** Displays of the layout */
    public displays: any;

    constructor(data: any) {
        this.name = data.name;
        this.type = data.type;
        this.components = data.components;
        this.context = data.context;
        this.metadata = data.metadata;
        this.version = data.version;
        this.displays = data.displays;
    }
}
